<form [formGroup]="form">
    <app-material [material]="isMaterial">
        <app-material-header>{{title | translate}}</app-material-header>
        <app-material-body>
            <ng-content></ng-content>
        </app-material-body>
        <!-- TODO Add content selection as to allow forms that also have trailing inputs -->
    </app-material>
</form>
